import { type AnchorHTMLAttributes, type FC, type ReactNode } from 'react'

import { buttonClassName, type ButtonSize, type ButtonVariant } from '@/components/core/Button/buttonClassName'

// ButtonLink shares Button's stylesheet — the `.button` classes must ship even on a
// page that renders no <button>.
import '@/components/core/Button/index.scss'

export interface ButtonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  href: string
  children: ReactNode
}

/**
 * An anchor that looks like a Button. Use it whenever the action is a real navigation
 * (a `href` the browser follows) rather than an in-page handler — it keeps middle-click,
 * "open in new tab", and no-JS behaviour that a <button> + location.assign() throws away.
 */
export const ButtonLink: FC<ButtonLinkProps> = ({ variant, size, className, children, ...props }) => (
  <a className={buttonClassName({ variant, size, className })} {...props}>
    {children}
  </a>
)
